import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { auth, initializePlacesService } from '@trip-planner-monorepo/shared';

/**
 * Initialize the Places API service after the app has mounted
 * This is a fallback to ensure the service is initialized even if
 * it didn't initialize properly in App.js
 */
const initServices = () => {
  // SECURITY: Only log in development mode, never expose API keys
  if (process.env.NODE_ENV === 'development') {
    console.log('In index.js - Can access NODE_ENV:', process.env.NODE_ENV);
    console.log('In index.js - Looking for Google API key...');
    const hasKey = !!process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
    console.log('In index.js - API key found?', hasKey);
    // SECURITY: Do not log any part of the actual key
  }

  // Use a short timeout to ensure environment variables are loaded
  setTimeout(() => {
    try {
      // For testing purposes only - uncomment and add your key if environment variables aren't working
      // const testApiKey = "your_actual_api_key_here";
      
      initializePlacesService({ 
        force: true,
        // Uncomment the line below to use a hardcoded key for testing
        // apiKey: testApiKey 
      });
      console.log('Fallback Places service initialization complete');
    } catch (error) {
      console.error('Fallback Places service initialization failed:', error);
      console.error('You may need to manually add your API key to packages/main-app/.env');
    }
  }, 1000);
};

// Verify Firebase initialization in development
if (process.env.NODE_ENV === 'development') {
  console.log('Firebase Auth initialization check:', {
    isInitialized: !!auth,
    currentUser: auth.currentUser,
    authDomain: auth.config?.authDomain,
    apiKey: auth.config?.apiKey?.substring(0, 8) + '...' // Log only first 8 chars for security
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // TEMP: Disabled StrictMode because it causes PlacesAutocomplete to remount
  // and destroys Google Places event listeners before they can fire
  // TODO: Fix PlacesAutocomplete to work with StrictMode's double-mounting
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// Initialize services after the app has mounted
initServices();